import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StructuredDataService {

  private readonly scriptId = 'cwk-structured-data-page';

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  setPageGraph(graph: object): void {
    this.setGraph(graph, this.scriptId);
  }

  setGraph(graph: object, id: string = this.scriptId): void {
    if (!graph) {
      return;
    }

    this.removeGraph(id);

    const script = this.document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = JSON.stringify(graph);
    this.document.head.appendChild(script);
  }

  removePageData(): void {
    this.removeGraph(this.scriptId);
  }

  removeGraph(id: string = this.scriptId): void {
    if (!id) {
      return;
    }

    const existing = this.document.getElementById(id);
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
  }
}
